import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  colors: {
    black: '#191A19',
    darkgray: '#607D8B',
    mediumgray: '#8898A0',
    lightgrey: '#dcdedf',
    pink: {
      1200: '#9233ff',
      1100: '#ad66ff',
      1000: '#c999ff',
      900: '#85046a',
      800: '#8f1b77',
      700: '#99007a',
      600: '#b3008f',
      500: '#cc00a3',
      400: '#ff00cc',
      300: '#ff33d6',
      200: '#ff66e0',
      100: '#ff99eb',
      50: '#ffccf5',
    },
    purple: {
      900: '#24004d',
      800: '#300066',
      700: '#5f00cc',
      600: '#5f00cc',
      500: '#7700ff',
      400: '#9233ff',
      300: '#ad66ff',
      200: '#c999ff',
      100: '#e4ccff',
    },
    red: {
      900: '#4d0000',
      800: '#b30000',
      700: '#e60000',
      600: '#ff3333',
      500: '#ff4d4d',
      400: '#ff8080',
      300: '#ff9999',
      200: '#ffb3b3',
      100: '#ffcccc',
    },
    orange: {
      900: '#996300',
      800: '#b37400',
      700: '#cc8500',
      600: '#e69500',
      500: '#ffa600',
      400: '#ffb833',
      300: '#ffdb99',
      200: '#ffe4b3',
      100: '#ffedcc',
    },
    darkblue: {
      600: '#062946',
      500: '#08375e',
      400: '#0a4575',
      300: '#0c538d',
      200: '#0e61a4',
      100: '#106fbc',
    },
    blue: {
      900: '#127cd3',
      800: '#148aeb',
      700: '#2c96ed',
      600: '#43a2ef',
      500: '#5badf1',
      400: '#72b9f3',
      300: '#8ac5f5',
      200: '#a1d0f7',
      100: '#b8dcf9',
      50: '#e7f3fd',
    },
  },
})

export default theme
